export default __webpack_public_path__ + "images/2f00f4864322b616cb18f24aa64fec1e-pricing_sales.png";